import { PartialPropertyUpdateTree } from "@animech/axiom-format";
import { RootProperty } from "@definitions";
import type { RoomAppearance } from "src/scene";

export const serializedUndefined = "§§undefined§§";
export const serializedNil = "§§nil§§";

export const sessionDataVersions = ["1.0.0"] as const;
export type SessionDataVersion = (typeof sessionDataVersions)[number];
export const currentSessionDataVersion = sessionDataVersions.at(
	-1,
) as SessionDataVersion;

export type ConfigurationDelta = PartialPropertyUpdateTree<RootProperty>;
export type SessionData = {
	version: SessionDataVersion;
	configurationDelta: ConfigurationDelta;
	/** Absent in designs saved before the room could be styled. */
	room?: RoomAppearance;
};
